// extracted by mini-css-extract-plugin
module.exports = {"question":"QuestionHeader_question__2X2VF","title":"QuestionHeader_title__1SrPY","note":"QuestionHeader_note__JGyJV"};